import notificationStyle from "../../assets/scss/Notification.module.scss";


const ContactDetails = () => {
    const notification_list = [
        {
            id: 1,
            bg:1,
            icon: "ri-time-line fs-5 mt-0",
            title: "Business Hours:",
            value:'8AM-9PM EST'
        },
        {
            id: 2,
            bg:2,
            icon: "ri-time-line fs-5 mt-0",
            title: "Holiday Hours:",
            value:'8AM-9PM EST'
        },
        {
            id: 3,
            bg:3,
            icon: "ri-phone-line fs-5 mt-0",
            title: "Phone:",
            value:'708-942-1750',
            href: "tel:+708-942-1750"
        },
        {
            id: 4,
            bg:4,
            icon: "ri-mail-line fs-5 mt-0",
            title: "Email:",
            value:'activations@jznmarket.com',
            href: "mailto:activations@jznmarket.com"
        },
         {
            id: 5,
            bg:1,
            icon: "ri-user-line fs-5 mt-0",
            title: "Sales Representative:",
            value:'Activation Department'
        },
        {
            id: 6,
            bg:2,
            icon: "ri-phone-line fs-5 mt-0",
            title: "call sales Representative:",
            value:'Activation Department'
        },
         {
            id: 7,
            bg:3,
            icon: "ri-mail-line fs-5 mt-0",
            title: "Email sales Representative:",
            value:'activations@jznmarket.com',
            href: "mailto:activations@jznmarket.com"
        },
    ];
    return (
        <div className={notificationStyle.notification_menu}>
            <p className={notificationStyle.menu_title}>Contact Details</p>
            {notification_list?.map((data) => (
                <a
                     href={data.href || "#"}
                    key={data.id}
                    className={`${notificationStyle.notification} d-flex align-items-center text-decoration-none p-1`}
                onClick={(e) => {
                        if (!data.href) e.preventDefault();
                    }}
                >
                    <i className={data.icon}></i>
                    <p className="">{data.title} {data.value}</p>
                </a>
            ))}
        </div>
    );
};

export default ContactDetails;

